export default () => ({
    restrict: 'E',
    template: "<div class='front tile' ng-transclude></div>",
    transclude: true,
});
